module.exports = __webpack_public_path__ + "img/image (133).5d221639.jpg";